@import '~style-sheet-helpers/core.less';

.format-selection {
  width: calc(100% - 50px);
  > div {
    width: 100%;
  }
  button {
    width: 100%;
  }
}
